import bindEvent from '../../scripts/util/event/bindEvent';
import isElement from '../../scripts/util/DOM/isElement';
import addClass from '../../scripts/util/DOM/addClass';
import {forEach, find} from 'ramda';

const selectors = {
	el: '.js-tabs',
	control: '.js-tabs-control',
	tab: '.js-tab',
	content: '.js-tabs-content'
};

const classes = {
	states: {
		hidden: 'hidden',
		visible: 'visible'
	},
	control: {
		active: 'tabs__control_active'
	}
};

const toggleControl = (el, currentControl) => {
	const activeClassName = classes.control.active;
	const activeControl = el.querySelector(`.${activeClassName}`);
	if (activeControl) {
		activeControl.classList.remove(activeClassName);
	}
	currentControl.classList.add(activeClassName);
};

const filterTargetTab = id => item => item.dataset.tab === id;

const toggleTab = (el, id) => {
	const tabsContent = el.querySelector(selectors.content);
	const contentChilds = tabsContent.children;
	const targetTab = find(filterTargetTab(id))(contentChilds);
	if (targetTab) {
		forEach(addClass(classes.states.hidden))(contentChilds);
		targetTab.classList.remove(classes.states.hidden);
	}
};

const onClick = e => {
	const target = e.currentTarget;
	const el = target.closest(selectors.el);
	const tabId = target.dataset.tab;
	const disciplineId = target.dataset.id;
	const xy = target.dataset.xy;
	window.history.pushState({
		disciplineId: disciplineId,
		xy: xy
	}, '', '/curriculum/program/discipline/' + disciplineId + '/');
	setControl(xy);
};

const setControl = xy => {
	let target, el;
	target = document.querySelectorAll('li[data-xy="' + xy.split('-')[0] + '"]')[0];
	if (target) {
		el = target.closest(selectors.el);
		toggleControl(el, target);
		toggleTab(el, target.dataset.tab);
	}
	if (xy.split('-').length < 2) {
		xy += '-1';
	}
	target = document.querySelectorAll('li[data-xy="' + xy + '"]')[0];
	if (target) {
		el = target.closest(selectors.el);
		toggleControl(el, target);
		toggleTab(el, target.dataset.tab);
	}
};

const onBack = e => {
	const disciplineId = (e.state)? e.state.disciplineId : '';
	if (disciplineXY[disciplineId]) {
		setControl(disciplineXY[disciplineId]);
	}
	else if (disciplineDefault) {
		setControl(disciplineXY[disciplineDefault]);
	}
	else {
		setControl('1-1');
	}
};

const onReady = e => {
	const parts = location.href.split("/");
	let last = parts.pop();
	if (last === '') last = parts.pop();
	if (disciplineXY[last]) {
		setControl(disciplineXY[last]);
	} 
	else if (disciplineDefault) {
		setControl(disciplineXY[disciplineDefault]);
	}
	else {
		setControl('1-1');
	}
};

const setHandlers = () => {
	bindEvent(selectors.control, 'click', onClick);
	bindEvent('window', 'popstate', onBack);
	bindEvent('window', 'load', onReady);
};

const render = () => {
	if (isElement(selectors.el)) {
		setHandlers();
	}
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/tabs/index.js